export default {
  truncate: function (text, stop, clamp) {
    return text.slice(0, stop) + (stop < text.length ? clamp || '...' : '')
  },
  split: function (input, splitChar, splitIndex) {
    return input.split(splitChar)[splitIndex]
  }
}
